import { useState } from 'react'
import { ButtonGroup } from 'stories/components'

import { HardcodedTasksConfig } from './HardcodedTasksConfig'

const tabs = {
  hardcodedTasks: 'Hardcoded Tasks',
}

export const TasksConfig = () => {
  const [tab, setTab] = useState('hardcodedTasks')

  const renderContent = () => {
    switch (tab) {
      case 'hardcodedTasks':
        return <HardcodedTasksConfig />
    }
  }
  return (
    <div>
      <ButtonGroup title={tabs} value={tab} onChange={setTab} />

      {renderContent()}
    </div>
  )
}
